import { render, staticRenderFns } from "./ForgotPasswordModal.vue?vue&type=template&id=0901ab65&scoped=true&"
import script from "./ForgotPasswordModal.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordModal.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPasswordModal.vue?vue&type=style&index=0&id=0901ab65&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0901ab65",
  null
  
)

export default component.exports